<template>
  <div class="custom-card">
    <v-toolbar-title class="mb-4 py-2" style="border-bottom: 1px solid #d4dbe0">
      <span>PAGOS: INSCRIPCIONES PROGRAMAS UNIVERSIDAD</span>
    </v-toolbar-title>

    <v-row dense>
      <v-col cols="12" md="6" lg="4" offset-md="3" offset-lg="4">
        <v-form @submit.prevent="manejarImportacion">
          <v-card class="my-4" outlined>
            <v-card-title class="text-h6">Importar Datos</v-card-title>

            <v-card-text>
              <p>Seleccione el archivo que desea importar.</p>
              <v-file-input
                v-model="archivo"
                outlined
                show-size
                truncate-length="50"
                label="Archivo"
                accept=".csv"
                :disabled="cargando" />
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn type="submit" color="primary" :disabled="archivo == null || cargando" :loading="cargando">
                Obtener Insc. Progr. Univ.
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import inscripcionProgramaUniversidadExcelService from '../services/inscripcion-programa-universidad-excel.service';
export default {
  name: 'InscripcionesProgramasUniversidadLayout',
  created() {},
  mounted() {},
  data() {
    return {
      cargando: false,
      archivo: null,
    };
  },
  methods: {
    async manejarImportacion() {
      if (this.archivo) {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const archivoBase64 = e.target.result.split(',')[1];
          this.cargando = true;

          try {
            const response = await inscripcionProgramaUniversidadExcelService.findPorCodigosProgramasUniversidad({
              archivoBase64,
            });
            const data = response.data;
            const mensaje = data?.mensaje || 'Archivo con inscripciones programa universidad generado correctamente';
            const blob = new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const link = document.createElement('a');
            const fecha = new Date();
            const nombreArchivo = `inscripciones_programas_universidad_${fecha
              .toISOString()
              .slice(0, 10)}_${fecha.getTime()}.xlsx`;

            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', nombreArchivo);
            document.body.appendChild(link);
            link.click();

            this.archivo = null;
            this.$notify({
              group: 'notifications',
              title: 'Éxito',
              text: mensaje,
              type: 'success',
            });
          } catch (error) {
            const response = error?.response;
            const data = response?.data;
            const mensaje = data?.mensaje || 'Error al importar el archivo';

            window.console.error(mensaje);

            this.$notify({
              group: 'notifications',
              title: 'Error',
              text: mensaje,
              type: 'error',
            });
          } finally {
            this.cargando = false;
          }
        };
        reader.readAsDataURL(this.archivo);
      }
    },
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 8px;
  margin: 0px 8px 0px 8px;
}
</style>